import React from 'react';
import {
  createEnhancedStore,
  connectAuthSync,
} from '@tkww/ads-content-component-favorite-button/lib/store';

export default class FavoriteStore extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {ids} = this.props;
    if (!window.FavoritesStore) {
      const store = createEnhancedStore([...ids], ids.length);
      connectAuthSync(store);
      window.FavoritesStore = store ?? null;
    }

    if (!document.getElementById('custom-overlay-container')) {
      const el = document.createElement('div');
      el.id = 'custom-overlay-container';
      document.body.insertBefore(el, document.body.firstChild);
    }
  }

  render() {
    return null;
  }
}
